import { ChangeDetectionStrategy, Component, input } from "@angular/core";

import { MinimalSubscription } from "../../../pages/subscription-detail/types";
import { LoaderComponent } from "../../common/loader/loader";
import { NotAuthorizedComponent } from "../../common/not-authorized/not-authorized";
import { NotFoundComponent } from "../../common/not-found/not-found";
import { PageComponent } from "../../page/page";

@Component({
  selector: "subscription-page",
  template: `
    <page [subscription]="subscription()" [reportedStatus]="reportedStatus()">
      @if (isLoading()) {
        <loader />
      } @else if (isNotFound()) {
        <not-found />
      } @else if (isNotAuthorized()) {
        <not-authorized />
      } @else {
        <ng-content />
      }
    </page>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LoaderComponent, NotAuthorizedComponent, NotFoundComponent, PageComponent],
})
export class SubscriptionPageComponent {
  subscription = input.required<MinimalSubscription | undefined>();
  reportedStatus = input("");
  isLoading = input.required<boolean>();
  isNotFound = input.required<boolean>();
  isNotAuthorized = input.required<boolean>();
}
